import { useCallback } from 'react';

import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useSearchPlayerAvailableBonusTemplates = () => {
    const send = useGenericSend();

    return useCallback(
        async (request: Types.ISearchPlayerAvailableBonusTemplatesRequestData):
        Promise<Types.ISearchPlayerAvailableBonusTemplatesResponseData> => {
            const { data } = await send<Types.ISearchPlayerAvailableBonusTemplatesRequestData,
                Types.ISearchPlayerAvailableBonusTemplatesResponseData>({
                ID: 31143,
                responses: [31144, 31145],
                description: 'Search Player Available Bonus Templates',
                errorLevel: 1,
                ...request
            });

            return data;
        }, [
            send
        ]);
};
